/* Mobile nav drawer — the burger had no menu behind it until 2026-09-14.
   Built from the page's own header links so active states and per-page
   differences carry over automatically. Desktop nav is untouched. */
(function(){
  var head = document.querySelector('.sitehead');
  var burger = head && head.querySelector('.burger');
  if (!burger) return;

  var links = Array.prototype.slice.call(head.querySelectorAll('nav a'));
  var cta = head.querySelector('.hcta');
  var logo = head.querySelector('.logo');
  var sw = document.querySelector('[data-tsw]');   // For Men / For Women switch (offer bar on desktop)
  var lsq = document.body.classList.contains('stage-light') ? '?view=women' : '';

  var wrap = document.createElement('div');
  wrap.className = 'mnav';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-label', 'Menu');
  var linksHtml = links.map(function(a){
    return '<a href="' + a.getAttribute('href') + '"' +
           (a.classList.contains('on') ? ' class="on"' : '') + '>' +
           a.textContent + '</a>';
  }).join('');
  wrap.innerHTML =
    '<div class="mnav-top">' +
      (logo ? '<img src="' + logo.getAttribute('src') + '" alt="Maneup Labs">' : '') +
      '<button class="mnav-x" aria-label="Close menu">&times;</button>' +
    '</div>' +
    '<div class="mnav-links">' + linksHtml + '</div>' +
    '<div class="mnav-cta">' +
      (cta ? '<a class="btn" href="' + cta.getAttribute('href') + '">' + cta.textContent + ' <i class="ar">&rarr;</i></a>' : '') +
    '</div>' +
    '<div class="mnav-sub"><a href="/account">Account</a> &nbsp;&middot;&nbsp; <a href="/pages/help' + lsq + '">Help Center</a></div>' +
    (sw ? '<div class="mnav-sw"><span class="lab">Shopping</span>' + sw.outerHTML.replace(' data-tsw', '') + '</div>' : '');
  document.body.appendChild(wrap);

  function open(){ wrap.classList.add('on'); document.documentElement.style.overflow = 'hidden'; }
  function close(){ wrap.classList.remove('on'); document.documentElement.style.overflow = ''; }
  burger.style.cursor = 'pointer';
  burger.setAttribute('role', 'button');
  burger.setAttribute('aria-label', 'Open menu');
  burger.addEventListener('click', open);
  wrap.querySelector('.mnav-x').addEventListener('click', close);
  wrap.addEventListener('click', function(e){ if (e.target.closest('a')) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();
